import { extensions } from '../extensions/Extensions';
import { GifAsset } from './GifAsset';

export * from './index';

extensions.add(GifAsset);
